"use client";

import { useEffect } from "react";
import { CreateSiteSource } from "@/api-service/siteSource";
import LABELS from "@/components/global-constant/src/general";

export default function SiteSourceTracker() {
  useEffect(() => {
    const sendReferrer = async () => {
      try {
        const referrer = document.referrer;
        if (!referrer) return;

        const refUrl = new URL(referrer);
        const currentHost = window.location.host;

        if (refUrl.host === currentHost) {
          return;
        }

        const siteName = refUrl.hostname;

        await CreateSiteSource({
          sourceName: siteName,
          sourceUrl: refUrl.href,
          description: LABELS.ANALYTICS?.DEFAULT_EXTERNAL_SOURCE_DESC
        });
      } catch (error) {

        console.error("Error sending referrer:", error);
      }
    };

    sendReferrer();
  }, []);

  return null;
}
